import React from 'react';
import {
	FormattedNumber,
} from 'react-intl';

import type CK from '~/types/contentking';

import DisplayPart from '~/components/atoms/forms/basis/DisplayPart';
import EditableFormWrapper from '~/components/atoms/forms/basis/EditableFormWrapper';
import FormRow from '~/components/atoms/forms/basis/FormRow';
import FormRows from '~/components/atoms/forms/basis/FormRows';
import Fraction from '~/components/logic/Fraction';
import Parenthesis from '~/components/logic/Parenthesis';
import StaticText from '~/components/atoms/forms/components/StaticText';

import useWebsiteQuotas from '~/hooks/useWebsiteQuotas';



type Props = {
	websiteId: CK.WebsiteId,
};

const WebsiteAdminUsageOverview: React.FC<Props> = (props) => {
	const {
		websiteId,
	} = props;

	const websiteQuotas = useWebsiteQuotas(websiteId);

	if (websiteQuotas === null) {
		return null;
	}

	const allCount = websiteQuotas.find((quota) => quota.type === 'all')?.count ?? 0;
	const nonpagesCount = websiteQuotas.find((quota) => quota.type === 'other')?.count ?? 0;
	const nonpagesLimit = websiteQuotas.find((quota) => quota.type === 'other')?.limit ?? 1000;
	const sitemapsCount = websiteQuotas.find((quota) => quota.type === 'sitemaps')?.count ?? 0;
	const sitemapsLimit = websiteQuotas.find((quota) => quota.type === 'sitemaps')?.limit ?? 1000;

	return (
		<EditableFormWrapper
			isForAdmins={true}
			isReadOnly={true}
			title="Usage overview"
		>
			<DisplayPart>
				<FormRows>
					<FormRow label="Non-pages usage">
						<StaticText>
							<Fraction
								partA={(
									<FormattedNumber value={nonpagesCount} />
								)}
								partB={(
									<FormattedNumber value={nonpagesLimit} />
								)}
							/>
							{' '}
							<span className="percentage">
								<Parenthesis
									content={(
										<FormattedNumber
											style="percent"
											value={nonpagesCount / nonpagesLimit}
										/>
									)}
								/>
							</span>
						</StaticText>
					</FormRow>

					<FormRow label="Sitemaps usage">
						<StaticText>
							<Fraction
								partA={(
									<FormattedNumber value={sitemapsCount} />
								)}
								partB={(
									<FormattedNumber value={sitemapsLimit} />
								)}
							/>
							{' '}
							<span className="percentage">
								<Parenthesis
									content={(
										<FormattedNumber
											style="percent"
											value={sitemapsCount / sitemapsLimit}
										/>
									)}
								/>
							</span>
						</StaticText>
					</FormRow>

					<FormRow label="Total URLs">
						<StaticText>
							<FormattedNumber value={allCount} />
						</StaticText>
					</FormRow>
				</FormRows>
			</DisplayPart>
		</EditableFormWrapper>
	);
};



export default WebsiteAdminUsageOverview;
